<template>
    <FinancialSituationCalculator ref="calculator" v-model="formValue"></FinancialSituationCalculator>
</template>

<script setup lang="ts">
import { App } from '../../../../typings/api-enums'
import { useVModel } from '@vueuse/core'
import { ecspPersonalComplianceProfileConfig } from '../../../account/personal/complianceProfile/ecspComplianceProfile'
import { getNaturalWidgetFormValidationRules, initializeNaturalWidgetForm } from '../../ESAC/form/forms'
import FinancialSituationCalculator from './FinancialSituationCalculator.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'

const props = defineProps<{
    modelValue: App.Services.ComplianceProfile.ECSP.Categories.EcspFinancialSituationDto
}>()

const calculator = ref<InstanceType<typeof FinancialSituationCalculator> | null>(null)

const emit = defineEmits(['update:modelValue'])

const formValue = useVModel(props, 'modelValue', emit)
const { saving } = storeToRefs(usePersonalAccountDataState())

watch(saving, () => {
    calculator.value.updatedStoredValues()
})

initializeNaturalWidgetForm(
    getNaturalWidgetFormValidationRules(
        ecspPersonalComplianceProfileConfig['Financial Situation'].validationKey,
        'ecsp'
    ),
    null,
    'ecsp'
)
</script>
